import { ActivatedRoute } from '@angular/router';
import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CommonProfileInfoComponent } from '../common-profile-info/common-profile-info.component';
import { NG_ICON_DIRECTIVES } from '@ng-icons/core';


@Component({
  selector: 'app-similar-community',
  standalone: true,
  imports: [CommonModule, CommonProfileInfoComponent,
    NG_ICON_DIRECTIVES,
  ],
  templateUrl: './similar-community.component.html',
  styleUrls: ['./similar-community.component.scss']
})
export class SimilarCommunityComponent implements OnInit, OnChanges {

  @Input('title') title: string = 'Similar  Communities (Public search)';
  @Input() widgetDesc: string;
  @Input() suggestion: any;

  headerTitle: string = 'Similar  Communities (Public search)';
  user: any = [{a: 1}, {a: 2}, {a: 3}, {a: 4}];

  constructor(private a_route: ActivatedRoute) {
   }

  ngOnChanges(changes: SimpleChanges): void {
    // Handle widgetDesc changes for NgComponentOutlet compatibility
    if (changes.widgetDesc && changes.widgetDesc.currentValue) {
      this.headerTitle = changes.widgetDesc.currentValue;
    }
  }

  ngOnInit() {
    // Only set headerTitle if widgetDesc is provided (ngOnChanges handles dynamic updates)
    if (this.widgetDesc) {
      this.headerTitle = this.widgetDesc;
    }

    this.a_route.queryParams.subscribe((res) => {
        if(res.master && res.master!="NETWORK" && res.master!="TEAM" && res.menu!=null &&res.menu!=undefined){
          this.headerTitle=res.menu;
      }
   })
  }

}
